"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _UIExpandableText = _interopRequireDefault(require("UIComponents/text/UIExpandableText"));

var _UIExpandingTextArea = _interopRequireDefault(require("UIComponents/input/UIExpandingTextArea"));

var _PropertyIdentifier = require("customer-data-objects/property/PropertyIdentifier");

var propTypes = _UIExpandingTextArea.default.propTypes;

var PropertyInputExpandableText =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(PropertyInputExpandableText, _React$Component);

  function PropertyInputExpandableText(props) {
    var _this;

    (0, _classCallCheck2.default)(this, PropertyInputExpandableText);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(PropertyInputExpandableText).call(this, props));
    _this.handleChange = _this.handleChange.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(PropertyInputExpandableText, [{
    key: "focus",
    value: function focus() {
      this.refs.input.focus();
    }
  }, {
    key: "handleChange",
    value: function handleChange(event) {
      if (!(0, _PropertyIdentifier.isTextarea)(this.props.property)) {
        var value = event.target.value;

        if (event.target.value.includes('\n')) {
          // prevent newlines if not a textarea, for why we're doing this see https://git.hubteam.com/HubSpot/CRM-Issues/issues/4221
          return this.props.onChange((0, _extends2.default)({}, event, {
            target: (0, _extends2.default)({}, event.target, {
              value: value.replace(/\n/g, '')
            })
          }));
        }
      }

      return this.props.onChange(event);
    }
  }, {
    key: "getTransferrableProps",
    value: function getTransferrableProps() {
      var _this$props = this.props,
          __baseUrl = _this$props.baseUrl,
          __caretRenderer = _this$props.caretRenderer,
          __isInline = _this$props.isInline,
          __isExpandableTextInputEnabled = _this$props.isExpandableTextInputEnabled,
          __getProperty = _this$props.getProperty,
          __multiCurrencyCurrencyCode = _this$props.multiCurrencyCurrencyCode,
          __objectType = _this$props.objectType,
          __onCancel = _this$props.onCancel,
          __onInvalidProperty = _this$props.onInvalidProperty,
          __propertyIndex = _this$props.propertyIndex,
          __propertyInputComponentConfig = _this$props.propertyInputComponentConfig,
          __readOnlySourceData = _this$props.readOnlySourceData,
          __resolver = _this$props.resolver,
          __showError = _this$props.showError,
          __showPlaceholder = _this$props.showPlaceholder,
          __subject = _this$props.subject,
          __subjectId = _this$props.subjectId,
          __secondaryChanges = _this$props.secondaryChanges,
          __onSecondaryChange = _this$props.onSecondaryChange,
          __wrappers = _this$props.wrappers,
          __onTracking = _this$props.onTracking,
          __isRequired = _this$props.isRequired,
          __property = _this$props.property,
          transferrableProps = (0, _objectWithoutProperties2.default)(_this$props, ["baseUrl", "caretRenderer", "isInline", "isExpandableTextInputEnabled", "getProperty", "multiCurrencyCurrencyCode", "objectType", "onCancel", "onInvalidProperty", "propertyIndex", "propertyInputComponentConfig", "readOnlySourceData", "resolver", "showError", "showPlaceholder", "subject", "subjectId", "secondaryChanges", "onSecondaryChange", "wrappers", "onTracking", "isRequired", "property"]);
      return transferrableProps;
    }
  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement(_UIExpandableText.default, {
        buttonAlign: "left",
        hideButtonCaret: true
      }, _react.default.createElement(_UIExpandingTextArea.default, (0, _extends2.default)({}, this.getTransferrableProps(), {
        onChange: this.handleChange,
        ref: "input",
        shrink: true
      })));
    }
  }]);
  return PropertyInputExpandableText;
}(_react.default.Component);

exports.default = PropertyInputExpandableText;
PropertyInputExpandableText.propTypes = propTypes;
PropertyInputExpandableText.defaultProps = _UIExpandingTextArea.default.defaultProps;
module.exports = exports.default;